<template>
  <div>
    <div v-if="isHidden" class="hidden-value">
      <i v-help.mouse="`Hodnota této vlastnosti je pro vás skrytá.`" class="fas fa-eye-slash"></i>
      skrytá hodnota
    </div>
    <component :is="proxiedComponentName"
               v-else-if="proxiedComponentName"
               :id="id"
               :resFunction="resourceFunction" :color="color"
               :value="value" :tooltip="tooltip"
               :meta="meta"
               :propertyType="propertyType"
    ></component>
  </div>
</template>

<script>
import BooleanDetail from './boolean/detail'
import DateDetail from './date/detail'
import DateTimeDetail from './date-time/detail'
import IntervalDetail from './interval/detail'
import NumericDetail from './numeric/detail'
import StaticStringDetail from './static-string/detail'
import LinkUserDetail from './link-user/detail'
import LinkPersonDetail from './link-user/detail'
import TriggerDetail from './trigger/detail'
import LinkPersonResourceDetail from './link-resource/detail'
import LinkThingResourceDetail from './link-resource/detail'
import LinkPlaceResourceDetail from './link-resource/detail'
import LinkDetail from './link/detail'
import UrlDetail from './url/detail'
import EnumDetail from './enum/detail'
import ColorDetail from './color/detail'
import LongtextDetail from './longtext/detail'
import EntityStateDetail from './entity-state/detail'
import _ from 'lodash'

export default {
    name: 'PropertyDetailProxy',
    components: {
        StaticStringDetail,
        NumericDetail,
        IntervalDetail,
        DateDetail,
        DateTimeDetail,
        BooleanDetail,
        LinkUserDetail,
        TriggerDetail,
        LinkPersonResourceDetail,
        LinkThingResourceDetail,
        LinkPlaceResourceDetail,
        LinkPersonDetail,
        UrlDetail,
        LinkDetail,
        EnumDetail,
        ColorDetail,
        LongtextDetail,
        EntityStateDetail,
    },
    props: {
        value: { default: null, type: Object },
        id: { default: _ => '', type: String },
        tooltip: { default: _ => null, type: String },
        meta: { default: _ => {}, type: Object },
        color: { default: null },
    },
    data: function() {
        return {
            resourceFunction: null,
        }
    },
    computed: {
        propertyType() {
            return this.$store.getters.propertyTypeByKey(this.id) || {}
        },
        proxiedComponentName() {
            const component = _.chain(this.propertyType)
                .get('type')
                .camelCase()
                .upperFirst()
                .value() + 'Detail'
            if (component.indexOf('Person') !== -1) this.resourceFunction = 'person'
            if (component.indexOf('Thing') !== -1) this.resourceFunction = 'thing'
            if (component.indexOf('Place') !== -1) this.resourceFunction = 'place'
            if (_.get(this.$options.components, component)) {
                return component
            } else {
                console.warn(`Component ${component} is not defined! Falling back to StaticStringDetail for ${this.id}`)
                return 'StaticStringDetail'
            }
        },
        isHidden() {
            return _.get(this.value, '$hidden', false)
        },
    },
}
</script>

<style lang="scss" scoped>
    .hidden-value {
        color: orangered;
        text-align: center;
        width: 100%;
    }
</style>
